import { http } from 'utils'

// Application state.
const state = {
  //
}

// Application state getters.
const getters = {
  //
}

// Application actions.
const actions = {
  /**
   * Get the scheduled counts.
   */
  getLoadsScheduledCount ({ commit }) {
    return http.get('dashboard/scheduled-counts').then(response => {
      return response
    })
  },

  getCommissionData ({ commit }) {
    return http.get('dashboard/commission-data').then(response => {
      return response
    })
  },

  getLoadsPerDayGraph ({ commit }) {
    return http.get('dashboard/loads-per-day').then(response => {
      return response
    })
  },

  getCommissionPerDayGraph ({ commit }) {
    return http.get('dashboard/commission-per-day').then(response => response)
  },

  getScheduledLoadsGraph ({ commit }) {
    return http.get('dashboard/scheduled-loads').then(response => {
      return response
    })
  },

  getUserGrowthGraph ({ commit }) {
    return http.get('dashboard/user-growth').then(response => {
      return response
    })
  }
}

// Application state mutations.
const mutations = {
  //
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/dashboard.js